import React, { useEffect, useState, useCallback, useRef } from "react";
import Webcam from "react-webcam";
import styled from "styled-components";
import Dimensions from "react-dimensions";
import { Icon, Button, Row, Col } from "antd";
import {
  CloseOutlined,
  CameraOutlined,
  RetweetOutlined,
} from "@ant-design/icons";

import { XLg, Camera, ArrowRepeat } from "react-bootstrap-icons";

const CameraButton = styled.button`
  width: 50px;
  height: 50px;
  background: none;
  margin: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: dashed 1px #ffffff;
  color: #ffffff;
  font-size: 20px;
`;

const WebcamScreen = Dimensions({
  containerStyle: {
    width: "100vw",
    height: "100vh",
    position: "absolute",
    top: 0,
    left: 0,
  },
})((props) => {
  const [deviceIdx, setDeviceIdx] = useState(0);
  const [isPortrait, setIsPortrait] = useState(false);
  const [devices, setDevices] = useState([]);
  const [closeCamera, setCloseCamera] = useState(false);
  const webcamRef = useRef(null);
  const { className, children } = props;

  const { containerWidth, containerHeight, circle } = props;

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot({
      width: containerWidth,
      height: containerHeight,
    });
    if (props.onCapture) {
      props.onCapture(imageSrc, {
        containerWidth,
        containerHeight,
        circleWidth: circle ? containerWidth * 0.45 : containerWidth,
      });
    }
  }, [webcamRef]);

  const handleDevices = useCallback(
    (mediaDevices) => {
      const cameraDevices = mediaDevices.filter(
        ({ kind }) => kind === "videoinput"
      );
      setDevices(cameraDevices);
      if (cameraDevices.length === 0) {
        setCloseCamera(true);
      }
    },
    [setDevices]
  );

  useEffect(() => {
    /* Storing user's device details in a variable*/
    let details = window.navigator.userAgent;

    /* Creating a regular expression 
    containing some mobile devices keywords 
    to search it in details string*/
    let regexp = /android|iphone|kindle|ipad/i;
    let regexpTablet = /kindle|ipad/i;

    /* Using test() method to search regexp in details
    it returns boolean value*/
    let isMobileDevice = regexp.test(details);
    let isTabletDevice = regexpTablet.test(details);

    if (isMobileDevice) {
      if (isTabletDevice) {
        let wd = window.screen.width;
        let hg = window.screen.height;
        if (wd > hg) {
          // setIsPortrait(() => 'landscape');
          setIsPortrait(() => false);
        } else {
          setIsPortrait(() => true);
        }
      } else {
        setIsPortrait(() => true);
      }
    } else {
      setIsPortrait(() => false);
    }
    //TODO: Add isPortait to redux state
    // console.log("portrait ->", isPortrait)
    // localStorage.setItem('portrait', isPortrait);
  }, []);

  useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then(handleDevices);
  }, [handleDevices]);

  const CropViewport = styled.div`
    width: ${circle ? containerWidth * 0.45 : containerWidth}px;
    height: ${circle ? containerWidth * 0.45 : containerHeight}px;
    position: absolute;
    border: 2px solid #fff;
    margin: auto;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    box-shadow: 0 0 2000px 2000px rgba(0, 0, 0, 0.5);
    z-index: 0;
    border-radius: ${circle ? "50" : "100"}%;
  `;

  return !closeCamera ? (
    <div className={className}>
      {devices.length > 0 && (
        <Webcam
          audio={false}
          width={containerWidth}
          height={containerHeight}
          screenshotFormat="image/png"
          videoConstraints={{
            width: containerWidth,
            height: containerHeight,
            deviceId: devices[deviceIdx].deviceId,
          }}
          ref={webcamRef}
        />
      )}
      {circle && <CropViewport />}
      <Row className={"buttons-row"}>
        <Col>
          <CameraButton
            onClick={() => {
              setCloseCamera(true);
              if (props.onClose) {
                props.onClose();
              }
            }}
          >
            <XLg />
          </CameraButton>
        </Col>
        <Col>
          <CameraButton onClick={capture}>
            <Camera />
          </CameraButton>
        </Col>
        {devices.length > 1 && (
          <Col>
            <CameraButton
              onClick={() => {
                setDeviceIdx(
                  deviceIdx + 1 === devices.length ? 0 : deviceIdx + 1
                );
              }}
            >
              <ArrowRepeat />
            </CameraButton>
          </Col>
        )}
      </Row>
      {children}
    </div>
  ) : null;
});

const DesktopCamera = styled(WebcamScreen)`
  & {
    background: black;
    position: fixed;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
    z-index: 999999;
    video {
      width: 100%;
      height: unset;
      @media only screen and (orientation: portrait) {
        position: absolute;
        height: 100vh;
        width: 177.77777778vh; /* 100 * 16 / 9 */
        min-width: 100%;
        min-height: 56.25vw;
        left: 50%; /* % of surrounding element */
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .buttons-row {
      height: 100%;
      position: absolute;
      @media only screen and (orientation: landscape) {
        right: 0;
        top: 0;
      }
      flex: 1;
      flex-direction: column;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(0, 0, 0, 0.2);
       {
        button {
          width: 100px;
          height: 100px;
          background: none;
          margin: 10px;
          i {
            color: white;
            font-size: 36px;
            margin-top: 4px;
          }
        }
      }
      @media only screen and (orientation: portrait) {
        height: 20vh;
        width: 100%;
        flex-direction: row;
        bottom: 0 !important;
      }
    }
  }
`;

export default DesktopCamera;
